module.exports = __webpack_public_path__ + "static/media/solution25.ae0ecb0c.jfif";